import { types } from "../../types/types";

const initialState = {
  items: [],
  cargada: false,
  loading: false,
  seleccionado: null,
  disabled: true,
  error: null,
};

export const licenciasProfesionalesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.licenciasProfesionalesTraerStart:
          return {
            ...state,
            loading: true,
            error: null,
            cargada: false,
          };
        case types.licenciasProfesionalesTraerSuccess:
          return {
            ...state,
            loading: false,
            items: action.payload,
            cargada: true,
          };
        case types.licenciasProfesionalesTraerError:
          return {
            ...state,
            loading: false,
            error: action.payload,
            items: [],
            cargada: false,
          };
        case types.licenciasProfesionalesLimpiar:
          return {
            ...state,
            loading: false,
            items: [],
            cargada: false,
          };
        case types.licenciasProfesionalesSeleccionar:
          return {
            ...state,
            loading: false,
            seleccionado: action.payload,
            cargada: true,
          };
        case types.licenciasProfesionalesUpdateDisabled:
          return {
            ...state,
            disabled: action.payload,
          };
        case types.licenciasProfesionalesModificarInHabilitado:
          return {
            ...state,
            items: state.items.map( item => item.idEfectorLicencias === action.payload.idEfectorLicencias
              ? {...item, fecProCBaja: action.payload.habilitado} 
              : item
            ),
          };
        default:
          return state;
      }
    };
    